<template>
<div class="shop-item pr">
  <div
    v-if="shopItem.tagName"
    class="tag-module pa fs12"
  >
    {{shopItem.tagName}}
    <div class="triangle-icon pa"></div>
  </div>
  <div class="img-box up-down-left-right-center">
    <img
      class="product-img"
      :src="shopItem.frontImg"
      alt=""
    >
  </div>
  <div class="text-box">
    <div class="header-box line-text-flow">
      <div
        v-if="shopItem.isTop"
        class="product-tag stick"
      >
        {{$t('Sticky')}}
      </div>
      <span class="title">{{shopItem.productName}}</span>
    </div>
    <div class="intro line-text-flow">{{shopItem.intro}}</div>
    <div class="data-line display-flex space-between">
      <div class="integral-left">
        <img
          width="16px"
          src="../../assets/images/userCenter/integral.png"
          alt=""
        >
        <span class="integral-number">{{nowIntegral}}</span>
        <span
          v-if="shopItem.preferentialPrice"
          class="original-price"
        >{{shopItem.originalPrice}}</span>
      </div>
      <div class="sales">{{$t('Sales')}} {{shopItem.sales}}</div>
    </div>
  </div>
  <div class="footer-box">
    <el-row>
      <el-col :span="12">
        <div class="detail-btn" @click.stop="detailsHandle">{{$t('details')}}</div>
      </el-col>
      <el-col :span="12">
        <div
          class="copy-btn"
          @click="addCarHandle"
          v-loading="addLoading"
        >{{$t('add_to_the_cart')}}</div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import { addProductToCar } from '@/api/userCenter'
export default {
  name: 'shopItem',
  props: {
    shopItem: {
      type: Object,
      default(){
        return {

        }
      }
    }
  },
  data() {
    return {
      addLoading: false,
    };
  },
  computed: {
    nowIntegral() {
      if(this.shopItem.preferentialPrice){
        return this.shopItem.preferentialPrice;
      }else {
        return this.shopItem.originalPrice;
      }
    }
  },
  methods: {
    detailsHandle() {
      this.$router.push({name: 'productDetail',params: {id: this.shopItem.productId}});
    },
    addCarHandle(){
      // 加入购物车
      this.addLoading = true;
      addProductToCar({
        productId: this.shopItem.productId,
        quantity: 1,
      }).then((res) => {
        if(res&&res.code&&res.code == 200){
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2000,
          });
          this.$emit('add-car-success')
          setTimeout(() => {
            this.addLoading = false;
          },1000)
        }
        
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.shop-item {
  height: 350px;
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
  .tag-module {
    background-color: $themeGreen;
    top: 0;
    height: 24px;
    line-height: 24px;
    border-radius: 2px;
    border-bottom-right-radius: 0;
    right: -6px;
    color: #ffffff;
    padding: 0 10px;
    .triangle-icon {
      width: 0;
      height: 0;
      border: 3px solid #17785C;
      right: 0;
      bottom: -5px;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }
  .img-box {
    height: 200px;
    .product-img {
      max-width: 260px;
      max-height: 170px;
    }
  }
  .text-box {
    padding: 20px;
    padding-top: 0;
  }
  .header-box {
    margin-bottom: 10px;
    .product-tag {
      border-radius: 2px;
      color: #ffffff;
      font-size: 14px;
      display: inline-block;
      padding: 2px;
      margin-right: 5px;
      &.stick {
        background-color: $themeColor;
      }
    }
    .title {
      font-weight: 600;
      color: #333333;
      font-size: 16px;
    }
  }
  .intro {
    font-size: 14px;
    color: #999999;
    margin-bottom: 10px;
  }
  .data-line {
    font-size:14px;
    .integral-left {
      display: flex;
      justify-content: start;
      align-items: center;
    }
    .integral-number {
      color: $themeColor;
      margin-right: 10px;
      margin-left: 5px;
    }
    .sales,
    .original-price {
      color: #999999;
    }
    .original-price {
      text-decoration: line-through;
    }
  }
  .footer-box {
    border-top: 1px solid #E6E6E6;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 50px;
    .detail-btn,
    .copy-btn {
      height: 50px;
      line-height: 50px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: $themeColor;
        color: #ffffff;
      }
    }
    .detail-btn {
      border-right: 1px solid #E6E6E6;
      border-radius: 0 0 0 5px;
    }
    .copy-btn {
      border-radius: 0 0 5px 0;
    }
  }
}
</style>
